import { ActualBlockTimeInputInterface } from '../interfaces/actual-block-time-input.interface';
import { toHoursNumber } from './to-hours-number.helper';

/**
 * Calculates the actual block time with the legacy rule: OB + live + IB + cancellation.
 * The IB hours are not added if they are excluded.
 * The cancellation hours are added only for a cancelled-no-cost record.
 */
export function calculateActualBlockTime(input: ActualBlockTimeInputInterface): number {
  const ibHours = input.isIbExcluded ? 0 : toHoursNumber(input.ibHours);
  const cancellationHours = input.isCancelledNoCost ? toHoursNumber(input.cancellationHours) : 0;
  const sum = toHoursNumber(input.obHours) + toHoursNumber(input.liveFlightHours) + ibHours + cancellationHours;

  return Number(sum.toFixed(2));
}
